import { DatePicker as UiDatePicker } from "@components/ui/Datepicker";

import styles from "./DatePicker.module.css";

interface DatePickerProps {
  label: string;
  name: string;
  selected: Date | null | undefined;
  onSelect: (date: Date | null | undefined) => void;
  register: () => Record<string, any>;
  placeholder: string;
  /** See ui/Datepicker: "UTC" makes the picked day viewer-independent. */
  timeZone?: string;
}
export const DatePicker = ({
  selected,
  onSelect,
  register,
  placeholder,
  label,
  name,
  timeZone,
}: DatePickerProps) => {
  return (
    <div className="w-full">
      <label className={styles.datePickerLabel} htmlFor={name}>
        {label}
      </label>
      <div className={styles.datePickerContainer}>
        <UiDatePicker
          selected={selected}
          onSelect={onSelect}
          placeholder={placeholder}
          register={register}
          timeZone={timeZone}
          format={(date) =>
            date ? date.toLocaleDateString("en-US", { timeZone }) : undefined
          }
          options={{
            showOutsideDays: true,
            disabled: {
              after: new Date(),
            },
          }}
        />
      </div>
    </div>
  );
};
